/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  InputAdornment,
  Typography,
  IconButton,
  Chip,
  Card,
  CardContent,
  Tooltip,
  Fade,
  CircularProgress,
  Stack,
  Divider,
  Badge,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Print as PrintIcon } from "@mui/icons-material";
import RefreshIcon from "@mui/icons-material/Refresh";
import FilterListIcon from "@mui/icons-material/FilterList";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import DownloadIcon from "@mui/icons-material/Download";
import AddIcon from "@mui/icons-material/Add";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Edit as EditIcon, Close as CloseIcon } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import AnchorTemporaryDrawer from "../../components/Drawer";
import {
  fetchDataEngine,
  fetchDataEngineCustomized,
  generateAndExecuteMutation,
  graphqlQuery,
} from "../Axios/DynamicService";
import { useNavigate } from "react-router-dom";
import {
  DocumentAccessModal,
  UpdateCaseStatusModal,
  AssignTaskModal,
  EngagementLetterModal,
  CourtAttendanceSheetModal,
} from "./Modal";
import { useDispatch } from "react-redux";
import { UpdateDataToStore } from "../../store/Actions/CustomAction";
import usePermissions from "../RBAC/PermissionsHook";
import useSubRightPermissionsHook from "../RBAC/SubRightPermissionHook";
import {
  accountsmanagement,
  documentManagementUrl,
  documentUploadUrl,
} from "../../config";
import { deleteDocument, markTaskDone } from "./DynamicFunctions";
import Swal from "sweetalert2";
import SearchIcon from "@mui/icons-material/Search";
import { format } from "date-fns";
import JournalEntriesModal from "./JournalEntriesModal";
import PrintFeeNote from "../../scenes/ClientInvoicing/FeeNote/PrintFeeNote";
import PrintProformaNote from "../../scenes/ClientInvoicing/Proforma/PrintProformaNote";
import PrintCreditNote from "../../scenes/ClientInvoicing/CreditNote/PrintCreditNote";
import PrintReceipt from "../../scenes/ClientInvoicing/ClientReceipts/PrintReceipt";
import PrintInvoice from "../../scenes/ClientInvoicing/PurchaseInvoice/PrintInvoice";
import PrintVoucher from "../../scenes/SupplierInvoicing/PaymentVoucher/VoucherHeader/PrintVoucher";
import ImprestDisbursementForm from "../../scenes/HRManagemenet/ImprestByUser/ImprestDisbursementForm";
import ClaimDisbursementForm from "../../scenes/HRManagemenet/StaffClaimByUser/ClaimDisbursementForm";
import ViewDetailDialog from "../../scenes/HRManagemenet/Payroll/PayrollRun/ViewDetailDialog";
import { payrollLineDetailsColumns } from "../Columns/hrmanagement";
import PrintPayslip from "../../scenes/HRManagemenet/Payroll/PayrollRun/PrintPayslip";
import SelectPayrollRunModal from "../../scenes/HRManagemenet/EmployeeManagement/SelectPayrollRunModal";
import ManageClaimLinesWithDocuments from "../../scenes/HRManagemenet/StaffClaimByUser/ManageClaimLinesWithDocuments";
import ManageImprestLinesDialog from "../../scenes/HRManagemenet/ImprestByUser/ManageImprestLinesDialog";
import ManageSurrenderLinesDialog from "../../scenes/HRManagemenet/ImprestSurrender/ManageSurrenderLinesDialog";
import ManagePurchaseLinesDialog from "../../scenes/ClientInvoicing/PurchaseInvoice/ManagePurchaseLinesDialog";
import ManagePaymentVoucherLinesDialog from "../../scenes/SupplierInvoicing/Lines/voucherLineDialog";
import ManageStatutoryRatesDialog from "../../scenes/HRManagemenet/PayrollSetups/StatutoryRate/ManageStatutoryRateLinesDialog";
import ManageRelieversDialog from "../../scenes/HRManagemenet/LeaveApplications/ManageRelieversDialog";
import ManageEmployeePayDialog from "../../scenes/HRManagemenet/PayrollSetups/EmployeePayComponent/ManageEmployeePayDialog";
import ManageImprestLinesWithDocuments from "../../scenes/HRManagemenet/ImprestByUser/ManageLinesWithDocuments";
import { executeAnyMutation } from "../DynamicServiceNew/jsondynamicservice";

const base_file_path = documentManagementUrl.baseFilePath;

const DynamicTable = ({
  title,
  subtitle,
  columns = [], // Default to empty array to prevent undefined
  FormComponent,
  query,
  base_url,
  actions = {}, // Default to empty object
  DataFromGetBy = [], // Default to empty array
  loadingState,
  getRowId,
  onAction,
  filters = [], // NEW: Array of default filters
  // automatically sort by highest id first (newest record) across all tables
  defaultSortModel = [
    { field: "id", sort: "desc" },
    { field: "createdDate", sort: "desc" },
  ], // optional initial sort for the grid
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const dispatch = useDispatch();
  const { hasPermission } = usePermissions();
  const { hasSubRightPermission } = useSubRightPermissionsHook();
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [taskModalOpen, setTaskModalOpen] = useState(false);
  const [EngagementLetterModalOpen, setEngagementLetterModalOpen] =
    useState(false);
  const [CourtAttendanceSheetModalOpen, setCourtAttendanceSheetModalOpen] =
    useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [refreshTable, setRefreshTable] = useState(0);
  const hasDataObjectSource = Boolean(actions?.dataObject);
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const RoleGroupId = parseInt(decodedToken.RoleGroupId);
  const [updateCaseStatus, setUpdateCaseStatusModalOpen] = useState(false);
  const [assignDocumentAccessOpen, setAssignDocumentAccessOpen] =
    useState(false);
  // Add this state to your dynamic table component
  const [printOpen, setPrintOpen] = useState(false);
  const [printData, setPrintData] = useState([]);
  const [printComponent, setPrintComponent] = useState(null); // Add this to track which component to render

  const [searchTerm, setSearchTerm] = useState("");
  const [filterAnchor, setFilterAnchor] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [density, setDensity] = useState("standard");
  const [loading, setLoading] = useState(false);
  const UserId = parseInt(decodedToken.Id);
  const [journalModal, setJournalModal] = useState({
    open: false,
    accountId: null,
    accountName: "",
    journalData: [],
    loading: false,
  });
  // Inside DynamicTable component, add this state
  const [disburseImprestOpen, setDisburseImprestOpen] = useState(false);
  const [disburseClaimOpen, setDisburseClaimOpen] = useState(false);
  const [disburseRow, setDisburseRow] = useState(null);

  const [activeFilters, setActiveFilters] = useState(filters);
  const [viewDetailOpen, setViewDetailOpen] = useState(false);
  const [detailRow, setDetailRow] = useState(null);
  const [detailData, setDetailData] = useState([]);
  const [detailLoading, setDetailLoading] = useState(false);
  const [payrollRunModalOpen, setPayrollRunModalOpen] = useState(false);
  const [pendingEmployeeId, setPendingEmployeeId] = useState(null); // employeeId while modal is open
  const [claimLinesDialogOpen, setClaimLinesDialogOpen] = useState(false);
  const [selectedClaimForLines, setSelectedClaimForLines] = useState(null);
  const [purchaseLinesDialogOpen, setPurchaseLinesDialogOpen] = useState(false);
  const [selectedPurchaseForLines, setSelectedPurchaseForLines] =
    useState(null);
  const [paymentLinesDialogOpen, setPaymentLinesDialogOpen] = useState(false);
  const [selectedPaymentForLines, setSelectedPaymentForLines] = useState(null);
  const [statutoryRatesDialogOpen, setStatutoryRatesDialogOpen] =
    useState(false);
  const [selectedStatutoryForRates, setSelectedStatutoryForRates] =
    useState(null);
  const [relieversDialogOpen, setRelieversDialogOpen] = useState(false);
  const [
    selectedLeaveApplicationForRelievers,
    setSelectedLeaveApplicationForRelievers,
  ] = useState(null);
  const [employeePayDialogOpen, setEmployeePayDialogOpen] = useState(false);
  const [selectedEmployeeForPayStructure, setSelectedEmployeeForPayStructure] =
    useState(null);
  const [imprestLinesDialogOpen, setImprestLinesDialogOpen] = useState(false);
  const [selectedImprestForLines, setSelectedImprestForLines] = useState(null);
  const [surrenderLinesDialogOpen, setSurrenderLinesDialogOpen] =
    useState(false);
  const [selectedSurrenderForLines, setSelectedSurrenderForLines] =
    useState(null);

  const handleMarkTaskDone = async (id) => {
    try {
      const response = await markTaskDone(id);
      if (response) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Task marked as done successfully`,
        });
        setRefreshTable(true);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Unable to mark the task as done, try again later.",
        });
      }
      // Example: log the response
    } catch (error) {
      // Handle any errors that occur during the API call
      console.error("Error marking task as done:", error);
    }
  };

  const handleDeleteDocument = async (fileName, documentId) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to delete this document? This action cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      });

      if (confirmation.isConfirmed) {
        const response = await deleteDocument(fileName, documentId);
        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Document deleted successfully.`,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "Unable to delete the document, try again later.",
          });
        }
      } else {
        Swal.fire({
          icon: "info",
          title: "Cancelled",
          text: "The document is safe.",
        });
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };
  const handleSubmit = async (id) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to submit this document? This action cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, submit it!",
        cancelButtonText: "No, keep it",
      });

      if (confirmation.isConfirmed) {
        const mutationData = {
          id: id,
        };
        const response = await generateAndExecuteMutation(
          actions.submit.inputObjectName,
          mutationData,
          actions.submit.inputSubObjectName,
          base_url,
        );
        if (Object.values(response)[0] != null) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Document submited successfully.`,
          });
        }
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };
  const openPayrollLineDetails = async (row) => {
    setDetailRow(row);
    setDetailLoading(true);
    setViewDetailOpen(true);

    try {
      const result = await fetchDataEngine(
        "payrollDetailsByPayrollineId", // queryName
        "payrollLineDetail", // modelName (matches your GraphQL input object)
        { payrollLineId: Number(row.id) }, // inputFields
        [
          // returnFields
          "id",
          "payrollLineId",
          "payComponentId",
          "employeeName",
          "payComponentName",
          "amount",
          "isDeduction",
          "isStatutory",
          "calculationNotes",
        ],
        base_url, // base_url from props
      );

      // fetchDataEngine returns the array directly (or null)
      setDetailData(result || []);
    } catch (err) {
      console.error("Failed to load payroll line details:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not load line details.",
      });
      setDetailData([]);
    } finally {
      setDetailLoading(false);
    }
  };
  const handleRemoveTeamMember = async (row) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you  want to remove this item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Remove!",
        cancelButtonText: "No, keep",
      });

      if (confirmation.isConfirmed) {
        const mutationData = {
          ids: row.id,
          ...(actions.entity === "Team Assignments" && { userId: row.userId }),
          ...(actions.entity === "Judge Assignments" && {
            userId: row.judgeId,
          }),
          ...(actions.entity === "Court Assignments" && {
            userId: row.courtId,
          }),
          isActive: false,
          modelName: actions.RemoveItem.modelName,
        };

        const response = await generateAndExecuteMutation(
          actions.RemoveItem.inputObjectName,
          mutationData,
          null,
          base_url,
        );
        if (Object.values(response)[0] != null) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Item removed successfully.`,
          });
          setRefreshTable(true);
        }
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };

  const removeLeaveApprover = async (row) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you  want to remove this Approver?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Remove!",
        cancelButtonText: "No, keep",
      });

      if (confirmation.isConfirmed) {
        const mutationData = {
          id: row.id,
          UserId: row.userId,
          SsActive: 0,
        };
        const response = await generateAndExecuteMutation(
          actions.dataObject.inputObjectName,
          mutationData,
          "approvers",
          base_url,
        );
        if (Object.values(response)[0] != null) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Approver Removed successfully.`,
          });
          setRefreshTable(true);
        }
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };
  const approveProformaFeeNote = async (row) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you  want to remove this Approver?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Remove!",
        cancelButtonText: "No, keep",
      });

      if (confirmation.isConfirmed) {
        const mutationData = {
          id: row.id,
          userId: row.userId,
          isActive: 0,
        };
        const response = await generateAndExecuteMutation(
          "approveRejectProformaFeeNotesQuotations",
          mutationData,
          "approveModel",
          base_url,
        );
        if (Object.values(response)[0] != null) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Approver Removed successfully.`,
          });
          setRefreshTable(true);
        }
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };
  const approveClientReceipt = async (row) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you  want to remove this Approver?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Remove!",
        cancelButtonText: "No, keep",
      });

      if (confirmation.isConfirmed) {
        const mutationData = {
          id: row.id,
          userId: row.userId,
          isActive: 0,
        };
        const response = await generateAndExecuteMutation(
          "approveRejectProformaFeeNotesQuotations",
          mutationData,
          "approveModel",
          base_url,
        );
        if (Object.values(response)[0] != null) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Approver Removed successfully.`,
          });
          setRefreshTable(true);
        }
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };

  // const approveFeeNote = async (row) => {
  //   try {
  //     const confirmation = await Swal.fire({
  //       title: "Are you sure?",
  //       text: "Do you  want to remove this Approver?",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonText: "Yes, Remove!",
  //       cancelButtonText: "No, keep",
  //     });

  //     if (confirmation.isConfirmed) {
  //       const mutationData = {
  //         id: row.id,
  //         userId: row.userId,
  //         isActive: 0,
  //       };
  //       const response = await generateAndExecuteMutation(
  //         actions.dataObject.inputObjectName,
  //         mutationData,
  //         "approvers",
  //         base_url
  //       );
  //       if (Object.values(response)[0] != null) {
  //         Swal.fire({
  //           icon: "success",
  //           title: "Success!",
  //           text: `Approver Removed successfully.`,
  //         });
  //         setRefreshTable(true);
  //       }
  //     }
  //   } catch (error) {
  //     // Handle any errors that occur during the API call
  //     Swal.fire({
  //       icon: "error",
  //       title: "Error!",
  //       text: "An error occurred while processing your request. Please try again later.",
  //     });
  //   }
  // };
  const removeSurrenderLine = async (row) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: `Do you  want to remove this line?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Remove!",
        cancelButtonText: "No, keep",
      });

      if (confirmation.isConfirmed) {
        const mutationData = {
          id: row.id,
          applicationId: row.applicationId,
          amount: row.amount,
          description: row.description,
          isActive: 0,
        };
        // eslint-disable-next-line react/prop-types
        if (actions.dataObjectForMutation.isSurrenderLine) {
          mutationData.surrenderId = row.surrenderId;
        }

        const response = await generateAndExecuteMutation(
          actions.dataObjectForMutation.inputObjectName,
          mutationData,
          actions.dataObjectForMutation.inputSubObjectName,
          base_url,
        );
        if (Object.values(response)[0] != null) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Line Removed successfully.`,
          });
          setRefreshTable(true);
        }
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };
  const handleActivateDeactivate = async (activeValue, id, activeField) => {
    // Capture the state ONCE
    const currentActive =
      activeValue === true ||
      activeValue === 1 ||
      activeValue === "true" ||
      activeValue === "1";

    const newActive = !currentActive;

    const actionText = currentActive ? "deactivate" : "activate";

    console.log("INITIAL STATE:", {
      activeValue,
      currentActive,
      newActive,
      id,
      activeField,
    });

    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: `Do you want to ${actionText} ${actions.entity}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes, ${actionText} it!`,
        cancelButtonText: "No, keep it",
      });

      if (!confirmation.isConfirmed) {
        return;
      }

      let mutationData;

      if (
        actions.activateDeactivate.inputObjectName ===
        "bulkActivateDeactivateCompanies"
      ) {
        mutationData = {
          ids: [id],
          active: newActive,
        };
      } else if (actions.modelName) {
        mutationData = {
          modelName: actions.modelName,
          [activeField]: newActive,
          id: [id], // backend expects List<int>
        };
      } else {
        mutationData = {
          id: [id], // backend expects List<int>
          [activeField]: newActive,
        };
      }

      console.log("FINAL MUTATION:", mutationData);

      const response = await generateAndExecuteMutation(
        actions.activateDeactivate.inputObjectName,
        mutationData,
        actions.activateDeactivate.inputSubObjectName,
        base_url,
      );

      if (Object.keys(response)[0]) {
        await Swal.fire({
          icon: "success",
          title: "Success!",
          text: `${actions.entity} ${actionText}d successfully.`,
        });

        setRefreshTable(true);
      }
    } catch (error) {
      console.error("handleActivateDeactivate error:", error);

      Swal.fire({
        icon: "error",
        title: "Error!",
        text:
          error?.message || "An error occurred while processing your request.",
      });
    }
  };
  // handle approve fee note

  // handle approve fee note
  const handleApproveFeeNote = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const approvedStatusId = 3;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "Cannot approve. User ID is missing.",
      });
      return;
    }

    const confirmation = await Swal.fire({
      title: "Approve Fee Note?",
      text: `Do you want to approve Fee Note #${row.id}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "Cancel",
    });

    if (confirmation.isConfirmed) {
      try {
        const mutationData = {
          feeNoteId: row.id,
          approvedBy: currentUserId,
          statusId: approvedStatusId,
        };

        // Corrected function call
        const response = await generateAndExecuteMutation(
          "approveRejectFeeNotes", // 1. Pass the mutation NAME as a string
          mutationData,
          "approveModel", // 2. This is the variables object
          // 3. No sub-object name is needed
          base_url,
        );

        if (response && response.approveRejectFeeNotes.result != -1) {
          Swal.fire({
            icon: "success",
            title: "Approved!",
            text: `Fee Note #${row.id} approved successfully.`,
          });
          setRefreshTable(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Approval Failed",
            text: response.approveRejectFeeNotes.errorMessage,
          });
          console.error("Response:", response);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An error occurred while approving the Fee Note.",
        });
        console.error("Approval error:", error);
      }
    }
  };

  // handle approve fee note
  const handlePendingFeeNote = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const approvedStatusId = 2;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "Cannot approve. User ID is missing.",
      });
      return;
    }

    const confirmation = await Swal.fire({
      title: "Sent for Approval Fee Note?",
      text: `Do you want to send Fee Note #${row.id} for approval?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Sent it!",
      cancelButtonText: "Cancel",
    });

    if (confirmation.isConfirmed) {
      try {
        const mutationData = {
          feeNoteId: row.id,
        };
        if (
          row.amount <= 0 ||
          row.amount === null ||
          row.amount === undefined
        ) {
          Swal.fire({
            icon: "error",
            title: "Invalid Amount",
            text: "Cannot send for approval. Amount must be positive.",
          });
          return;
        }

        // Corrected function call
        const response = await generateAndExecuteMutation(
          "sendFeeNoteForApproval", // 1. Pass the mutation NAME as a string
          mutationData,
          null, // 2. This is the variables object
          // 3. No sub-object name is needed
          base_url,
        );

        if (response && response.sendFeeNoteForApproval.result != -1) {
          Swal.fire({
            icon: "success",
            title: "Sent!",
            text: `Fee Note #${row.id} send for Approval successfully.`,
          });
          setRefreshTable(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed to send for approval",
            text: response.sendFeeNoteForApproval.errorMessage,
          });
          console.error("Response:", response);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An error occurred while sending for approval the Fee Note.",
        });
        console.error("Approval error:", error);
      }
    }
  };
  const handlePendingImprest = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const approvedStatusId = 2;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "Cannot approve. User ID is missing.",
      });
      return;
    }

    const confirmation = await Swal.fire({
      title: "Send For Approval?",
      text: `Do you want to Sent the Imprest #${row.id} For Approval?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
      cancelButtonText: "Cancel",
    });

    if (confirmation.isConfirmed) {
      try {
        const mutationData = {
          imprestApplicationId: row.id,
        };

        // Corrected function call
        const response = await executeAnyMutation(
          "sendFeeImprestApplicationsForApproval", // 1. Pass the mutation NAME as a string
          mutationData,
          null, // 2. This is the variables object
          null,
          base_url,
        );

        if (response.results) {
          Swal.fire({
            icon: "success",
            title: "Sent!",
            text: `Imprest #${row.id} send for Approval successfully.`,
          });
          setRefreshTable(true);
        } else {
          const parsedError = response.error
            ? JSON.parse(response.error)
            : null;
          Swal.fire({
            icon: "error",
            title: "Failed to send for approval",
            text: parsedError || "An unknown error occurred.",
          });
          console.error("Response:", response);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An error occurred while sending fro approval.",
        });
        console.error("Approval error:", error);
      }
    }
  };
  const handlePendingPayrollRun = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const approvedStatusId = 2;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "Cannot approve. User ID is missing.",
      });
      return;
    }

    const confirmation = await Swal.fire({
      title: "Send For Approval?",
      text: `Do you want to Sent the Run #${row.id} For Approval?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
      cancelButtonText: "Cancel",
    });

    if (confirmation.isConfirmed) {
      try {
        const mutationData = {
          payrollRunId: row.id,
        };

        // Corrected function call
        const response = await generateAndExecuteMutation(
          "sendPayrollRunForApproval", // 1. Pass the mutation NAME as a string
          mutationData,
          null, // 2. This is the variables object
          // 3. No sub-object name is needed
          base_url,
        );

        if (response && response.sendPayrollRunForApproval.result != -1) {
          Swal.fire({
            icon: "success",
            title: "Sent!",
            text: `PayrollRun #${row.id} send for Approval successfully.`,
          });
          setRefreshTable(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed to send for approval",
            text: response.sendPayrollRunForApproval.errorMessage,
          });
          console.error("Response:", response);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An error occurred while sending fro approval.",
        });
        console.error("Approval error:", error);
      }
    }
  };

  const handlePendingStaffClaim = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const approvedStatusId = 2;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "Cannot approve. User ID is missing.",
      });
      return;
    }

    const confirmation = await Swal.fire({
      title: "Send For Approval?",
      text: `Do you want to Sent the Staff Claim #${row.id} For Approval?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
      cancelButtonText: "Cancel",
    });

    if (confirmation.isConfirmed) {
      try {
        const mutationData = {
          imprestApplicationId: row.id,
        };

        // Corrected function call
        const response = await generateAndExecuteMutation(
          "sendStaffClaimForApproval", // 1. Pass the mutation NAME as a string
          mutationData,
          null, // 2. This is the variables object
          // 3. No sub-object name is needed
          base_url,
        );

        if (response && response.sendStaffClaimForApproval.result != -1) {
          Swal.fire({
            icon: "success",
            title: "Sent!",
            text: `Staff Claim #${row.id} send for Approval successfully.`,
          });
          setRefreshTable(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed to send for approval",
            text: response.sendStaffClaimForApproval.errorMessage,
          });
          console.error("Response:", response);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An error occurred while sending fro approval.",
        });
        console.error("Approval error:", error);
      }
    }
  };
  const handleApprovePV = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const approvedStatusId = 3;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "Cannot approve. User ID is missing.",
      });
      return;
    }

    const confirmation = await Swal.fire({
      title: "Approve Payment Voucher",
      text: `Do you want to Payment Voucher?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "Cancel",
    });

    if (confirmation.isConfirmed) {
      try {
        const mutationData = {
          paymentVoucherId: row.id,
          approvedBy: currentUserId,
        };

        // Corrected function call
        const response = await generateAndExecuteMutation(
          "approveRejectPaymentVoucher", // 1. Pass the mutation NAME as a string
          mutationData,
          "approveModel", // 2. This is the variables object
          // 3. No sub-object name is needed
          base_url,
        );
        console.log("PV Approval full response →", response);
        console.log(
          "approveRejectPaymentVoucher object →",
          response?.approveRejectPaymentVoucher,
        );

        if (response && response.approveRejectPaymentVoucher) {
          Swal.fire({
            icon: "success",
            title: "Approved!",
            text: `Payment Voucher has been approved successfully.`,
          });
          setRefreshTable(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Approval Failed",
            text: "No data returned from server.",
          });
          console.error("Response:", response);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An error occurred while approving the PV.",
        });
        console.error("Approval error:", error);
      }
    }
  };

  const handleApproveImprest = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const APPROVED_STATUS = 3;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "User ID missing.",
      });
      return;
    }

    // ----- COMMENT INPUT -----
    const { value: comment } = await Swal.fire({
      title: "Approval Comment (optional)",
      input: "textarea",
      inputPlaceholder: "Enter any comment…",
      showCancelButton: true,
      confirmButtonText: "Approve",
      cancelButtonText: "Cancel",
    });

    if (comment === undefined) return; // user cancelled

    const confirm = await Swal.fire({
      title: "Approve Imprest?",
      text: `Imprest #${row.id}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve",
    });

    if (!confirm.isConfirmed) return;

    try {
      const mutationData = {
        id: row.id,
        approvedBy: currentUserId,
        status: APPROVED_STATUS,
        declinedReason: null, // not used for approve
      };

      const response = await executeAnyMutation(
        "approveRejectImprest", // mutation name
        mutationData, // variables
        "approveModel",
        null, // (optional) alias used by your helper
        base_url,
      );

      if (response?.results) {
        Swal.fire({
          icon: "success",
          title: "Approved!",
          text: "Imprest has been approved.",
        });
        setRefreshTable(true);
      } else {
        const parsedError = JSON.parse(response?.error || "{}");
        Swal.fire({
          icon: "error",
          title: "Approval Failed",
          text: parsedError || "Imprest approval was not successful.",
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to approve imprest.",
      });
    }
  };
  const handleRejectImprest = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const REJECTED_STATUS = 4;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "User ID missing.",
      });
      return;
    }

    // ----- REASON IS MANDATORY -----
    const { value: reason } = await Swal.fire({
      title: "Reason for Rejection",
      input: "textarea",
      inputPlaceholder: "Why are you rejecting this imprest?",
      inputValidator: (v) => (!v?.trim() ? "Reason is required" : null),
      showCancelButton: true,
      confirmButtonText: "Reject",
      cancelButtonText: "Cancel",
    });

    if (reason === undefined) return; // cancelled

    const confirm = await Swal.fire({
      title: "Reject Imprest?",
      text: `Imprest #${row.id}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reject",
    });

    if (!confirm.isConfirmed) return;

    try {
      const mutationData = {
        id: row.id,
        approvedBy: currentUserId,
        status: REJECTED_STATUS,
        declinedReason: reason.trim(),
      };

      const response = await generateAndExecuteMutation(
        "approveRejectImprest",
        mutationData,
        "approveModel",
        base_url,
      );

      if (response?.approveRejectImprest) {
        Swal.fire({
          icon: "success",
          title: "Rejected",
          text: "Imprest has been rejected.",
        });
        setRefreshTable(true);
      } else {
        throw new Error("No data returned");
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to reject imprest.",
      });
    }
  };

  const handleApprovePayroll = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const APPROVED_STATUS = 1;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "User ID missing.",
      });
      return;
    }

    const confirm = await Swal.fire({
      title: "Approve Payroll?",
      text: `Payroll ${row.id}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve",
    });

    if (!confirm.isConfirmed) return;

    try {
      const mutationData = {
        payrollRunId: row.id,
        approvedBy: currentUserId,
      };

      const response = await executeAnyMutation(
        "approvePayrollRun", // mutation name
        mutationData, // variables
        "approveModel",
        null, // (optional) alias used by your helper
        base_url,
      );

      if (response.results) {
        Swal.fire({
          icon: "success",
          title: "Approved!",
          text: "Payroll has been approved.",
        });
        setRefreshTable(true);
      } else {
        const parsedError = JSON.parse(response?.error || "{}");
        Swal.fire({
          icon: "error",
          title: "Approval Failed",
          text: parsedError.Error || "Payroll approval was not successful.",
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to approve Payroll.",
      });
    }
  };

  const handleRunPayroll = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const APPROVED_STATUS = 1;

    const confirm = await Swal.fire({
      title: "Calculate Payroll run?",
      text: `Payroll ${row.id}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Calculate",
    });

    if (!confirm.isConfirmed) return;

    try {
      const mutationData = {
        payrollRunId: row.id,
      };

      const response = await executeAnyMutation(
        "runPayrollRun", // mutation name
        mutationData, // variables
        "approveModel",
        null, // (optional) alias used by your helper
        base_url,
      );

      if (response.results) {
        Swal.fire({
          icon: "success",
          title: "Calculated!",
          text: "Payroll has been Caclculated.",
        });
        setRefreshTable(true);
      } else {
        const parsedError = JSON.parse(response?.error || "{}");
        Swal.fire({
          icon: "error",
          title: "Calculation Failed",
          text: parsedError.Error || "Payroll calculation was not successful.",
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to calculate Payroll.",
      });
    }
  };
  const handlePostPayroll = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const APPROVED_STATUS = 1;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "User ID missing.",
      });
      return;
    }

    const confirm = await Swal.fire({
      title: "post Payroll?",
      text: `Payroll ${row.id}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, post",
    });

    if (!confirm.isConfirmed) return;

    try {
      const mutationData = {
        payrollRunId: row.id,
        postedBy: currentUserId,
      };

      const response = await generateAndExecuteMutation(
        "postPayrollRun", // mutation name
        mutationData, // variables
        "approveModel", // (optional) alias used by your helper
        base_url,
      );

      if (response) {
        Swal.fire({
          icon: "success",
          title: "Posted!",
          text: "Payroll has been Posted.",
        });
        setRefreshTable(true);
      } else {
        throw new Error("No data returned");
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to post Payroll.",
      });
    }
  };
  const handleClosePayroll = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const APPROVED_STATUS = 1;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "User ID missing.",
      });
      return;
    }

    const confirm = await Swal.fire({
      title: "Close Payroll?",
      text: `Payroll ${row.id}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Close",
    });

    if (!confirm.isConfirmed) return;

    try {
      const mutationData = {
        payrollRunId: row.id,
        closedBy: currentUserId,
      };

      const response = await generateAndExecuteMutation(
        "closePayrollRun", // mutation name
        mutationData, // variables
        "approveModel", // (optional) alias used by your helper
        base_url,
      );

      if (response) {
        Swal.fire({
          icon: "success",
          title: "Posted!",
          text: "Payroll has been Closed.",
        });
        setRefreshTable(true);
      } else {
        throw new Error("No data returned");
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to Close Payroll.",
      });
    }
  };

  const handleApproveClaim = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const APPROVED_STATUS = 3;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "User ID missing.",
      });
      return;
    }

    // ----- COMMENT INPUT -----
    const { value: comment } = await Swal.fire({
      title: "Approval Comment (optional)",
      input: "textarea",
      inputPlaceholder: "Enter any comment…",
      showCancelButton: true,
      confirmButtonText: "Approve",
      cancelButtonText: "Cancel",
    });

    if (comment === undefined) return; // user cancelled

    const confirm = await Swal.fire({
      title: "Approve Claim?",
      text: `Claim #${row.id}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve",
    });

    if (!confirm.isConfirmed) return;

    try {
      const mutationData = {
        id: row.id,
        approvedBy: currentUserId,
        status: APPROVED_STATUS,
        declinedReason: null, // not used for approve
      };

      const response = await generateAndExecuteMutation(
        "aprroveRejectStaffClaim", // mutation name
        mutationData, // variables
        "approveModel", // (optional) alias used by your helper
        base_url,
      );

      if (response?.aprroveRejectStaffClaim) {
        Swal.fire({
          icon: "success",
          title: "Approved!",
          text: "Claim has been approved.",
        });
        setRefreshTable(true);
      } else {
        throw new Error("No data returned");
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to approve Claim.",
      });
    }
  };
  const handleRejectClaim = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const REJECTED_STATUS = 4;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "User ID missing.",
      });
      return;
    }

    // ----- REASON IS MANDATORY -----
    const { value: reason } = await Swal.fire({
      title: "Reason for Rejection",
      input: "textarea",
      inputPlaceholder: "Why are you rejecting this imprest?",
      inputValidator: (v) => (!v?.trim() ? "Reason is required" : null),
      showCancelButton: true,
      confirmButtonText: "Reject",
      cancelButtonText: "Cancel",
    });

    if (reason === undefined) return; // cancelled

    const confirm = await Swal.fire({
      title: "Reject Claim?",
      text: `Claim #${row.id}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reject",
    });

    if (!confirm.isConfirmed) return;

    try {
      const mutationData = {
        id: row.id,
        approvedBy: currentUserId,
        status: REJECTED_STATUS,
        declinedReason: reason.trim(),
      };

      const response = await generateAndExecuteMutation(
        "aprroveRejectStaffClaim",
        mutationData,
        "approveModel",
        base_url,
      );

      if (response?.aprroveRejectStaffClaim) {
        Swal.fire({
          icon: "success",
          title: "Rejected",
          text: "Claim has been rejected.",
        });
        setRefreshTable(true);
      } else {
        throw new Error("No data returned");
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to reject Claim.",
      });
    }
  };

  const handleApproveImprestSurrender = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const APPROVED_STATUS = 3;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "User ID missing.",
      });
      return;
    }

    // ----- OPTIONAL COMMENT INPUT -----
    const { value: comment } = await Swal.fire({
      title: "Approval Comment (optional)",
      input: "textarea",
      inputPlaceholder: "Enter any comment…",
      showCancelButton: true,
      confirmButtonText: "Approve",
      cancelButtonText: "Cancel",
    });

    if (comment === undefined) return; // user cancelled

    const confirm = await Swal.fire({
      title: "Approve Imprest Surrender?",
      text: `Imprest Surrender #${row.id}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve",
    });

    if (!confirm.isConfirmed) return;

    try {
      const mutationData = {
        surrenderId: row.id,
        approvedBy: currentUserId,
        status: APPROVED_STATUS,
        approverComments: comment?.trim() || null, // ✅ Use Swal input
        declinedReason: null,
      };

      const response = await generateAndExecuteMutation(
        "aprroveRejectImprestSurrender",
        mutationData,
        "approveModel",
        base_url,
      );

      if (response) {
        Swal.fire({
          icon: "success",
          title: "Approved!",
          text: "Imprest Surrender has been approved.",
        });
        setRefreshTable(true);
      } else {
        throw new Error("No data returned");
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to approve imprest surrender.",
      });
    }
  };

  const handleRejectImprestSurrender = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const REJECTED_STATUS = 4;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "User ID missing.",
      });
      return;
    }

    // ----- REASON IS MANDATORY -----
    const { value: reason } = await Swal.fire({
      title: "Reason for Rejection",
      input: "textarea",
      inputPlaceholder: "Why are you rejecting this imprest surrender?",
      inputValidator: (v) => (!v?.trim() ? "Reason is required" : null),
      showCancelButton: true,
      confirmButtonText: "Reject",
      cancelButtonText: "Cancel",
    });

    if (reason === undefined) return; // cancelled

    const confirm = await Swal.fire({
      title: "Reject Imprest Surrender?",
      text: `Imprest Surrender #${row.id}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reject",
    });

    if (!confirm.isConfirmed) return;

    try {
      const mutationData = {
        surrenderId: row.id,
        approvedBy: currentUserId,
        status: REJECTED_STATUS,
        approverComments: null,
        declinedReason: reason.trim(),
      };

      const response = await generateAndExecuteMutation(
        "aprroveRejectImprestSurrender",
        mutationData,
        "approveModel",
        base_url,
      );

      if (response?.approveRejectImprestSurrender) {
        Swal.fire({
          icon: "success",
          title: "Rejected",
          text: "Imprest Surrender has been rejected.",
        });
        setRefreshTable(true);
      } else {
        throw new Error("No data returned");
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to reject imprest surrender.",
      });
    }
  };

  const handleApproveClientReceipt = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    // const approvedStatusId = 3;
    console.log("Triggered:", "handleApproveClientReceipt");

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "Cannot approve. User ID is missing.",
      });
      return;
    }

    const confirmation = await Swal.fire({
      title: "Approve Receipt?",
      text: `Do you want to approve Receipt #${row.id}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "Cancel",
    });

    if (confirmation.isConfirmed) {
      console.log("Confirmed:", "handleApproveClientReceipt");

      try {
        const mutationData = {
          id: row.id,
          approvedBy: currentUserId,
          // statusId: approvedStatusId,
        };

        // Corrected function call
        const response = await generateAndExecuteMutation(
          "approveRejectReceipts", // 1. Pass the mutation NAME as a string
          mutationData,
          "approveModel", // 2. This is the variables object
          // 3. No sub-object name is needed
          base_url,
        );

        if (response && response.approveRejectReceipts) {
          // row.statusId = approvedStatusId;
          row.statusDescription = "Approved";
          row.status = "Approved";
          row.approvedBy = currentUserId;
          row.approvedDate = new Date().toISOString();

          Swal.fire({
            icon: "success",
            title: "Approved!",
            text: `Receipt #${row.id} approved successfully.`,
          });
          setRefreshTable(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Approval Failed",
            text: "No data returned from server.",
          });
          console.error("Response:", response);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An error occurred while approving the Fee Note.",
        });
        console.error("Approval error:", error);
      }
    }
  };

  const handleApprovePurchaseInvoice = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const approvedStatusId = 3;

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "Cannot approve. User ID is missing.",
      });
      return;
    }

    const confirmation = await Swal.fire({
      title: "Approve PurchaseInvoice?",
      text: `Do you want to approve PurchaseInvoice`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "Cancel",
    });

    if (confirmation.isConfirmed) {
      try {
        const mutationData = {
          purchaseInvoiceId: row.id,
          approvedBy: currentUserId,
        };

        // Corrected function call
        const response = await generateAndExecuteMutation(
          "approveRejectPurchaseInvoice", // 1. Pass the mutation NAME as a string
          mutationData,
          "approveModel", // 2. This is the variables object
          // 3. No sub-object name is needed
          base_url,
        );

        if (response && response.approveRejectPurchaseInvoice) {
          Swal.fire({
            icon: "success",
            title: "Approved!",
            text: `PurchaseInvoice approved successfully.`,
          });
          setRefreshTable(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Approval Failed",
            text: "No data returned from server.",
          });
          console.error("Response:", response);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An error occurred while approving the Fee Note.",
        });
        console.error("Approval error:", error);
      }
    }
  };

  const handleApproveProformaNote = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const approvedStatusId = 3;
    console.log("Triggered:", "handleApproveProformaNote");

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "Cannot approve. User ID is missing.",
      });
      return;
    }

    const confirmation = await Swal.fire({
      title: "Convert Profroma/Quotation Note?",
      text: `Do you want to convert Profroma/Quotation Note To a Feenote?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, convert it!",
      cancelButtonText: "Cancel",
    });

    if (confirmation.isConfirmed) {
      console.log("Confirmed:", "handleApproveProformaNote");
      try {
        const mutationData = {
          id: row.id,
          approvedBy: currentUserId,
          statusId: approvedStatusId,
        };

        // Corrected function call
        const response = await generateAndExecuteMutation(
          "approveRejectProformaFeeNotesQuotations", // 1. Pass the mutation NAME as a string
          mutationData,
          "approveModel", // 2. This is the variables object
          // 3. No sub-object name is needed
          base_url,
        );

        if (response && response.approveRejectProformaFeeNotesQuotations) {
          Swal.fire({
            icon: "success",
            title: "Converted!",
            text: `Profroma/Quotation #${row.id} converted successfully.`,
          });
          setRefreshTable(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Conversion Failed",
            text: "No data returned from server.",
          });
          console.error("Response:", response);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An error occurred while converting the Profroma/Quotation Note.",
        });
        console.error("Approval error:", error);
      }
    }
  };
  const handleApproveCreditNote = async (row) => {
    const decodedToken = JSON.parse(
      localStorage.getItem("decodedToken") || "{}",
    );
    const currentUserId = parseInt(decodedToken.Id) || null;
    const approvedStatusId = 3;
    console.log("Triggered:", "handleApproveCreditNote");

    if (!currentUserId) {
      Swal.fire({
        icon: "error",
        title: "Permission Denied",
        text: "Cannot approve. User ID is missing.",
      });
      return;
    }

    const confirmation = await Swal.fire({
      title: "Approve Credit Note?",
      text: `Do you want to approve Credit Note #${row.id}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "Cancel",
    });

    if (confirmation.isConfirmed) {
      console.log("Confirmed:", "handleApproveCreditNote");
      try {
        const mutationData = {
          id: row.id,
          approvedBy: currentUserId,
          statusId: approvedStatusId,
        };

        // Corrected function call
        const response = await generateAndExecuteMutation(
          "approveRejectCreditNotes", // 1. Pass the mutation NAME as a string
          mutationData,
          "approveModel", // 2. This is the variables object
          // 3. No sub-object name is needed
          base_url,
        );

        if (response && response.approveRejectCreditNotes) {
          Swal.fire({
            icon: "success",
            title: "Approved!",
            text: `Credit Note #${row.id} approved successfully.`,
          });
          setRefreshTable(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Approval Failed",
            text: "No data returned from server.",
          });
          console.error("Response:", response);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An error occurred while approving the Credit Note.",
        });
        console.error("Approval error:", error);
      }
    }
  };

  const handleApprove = async (row) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: `Do you want to approve this ${actions.actionName || "item"}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes, approve it!`,
        cancelButtonText: "No, keep it",
      });

      if (confirmation.isConfirmed) {
        const decodedToken = JSON.parse(
          localStorage.getItem("decodedToken") || "{}",
        );
        const currentUserId = parseInt(decodedToken.Id) || null;
        const leaveApplicationId = row.applicationId ?? row.id;
        const APPROVED_STATUS = 1;

        if (!leaveApplicationId || !currentUserId) {
          throw new Error("Missing required data for approval.");
        }

        // Build mutation data
        const mutationData = {
          applicationId: leaveApplicationId,
          userId: currentUserId,
          comments: "", // approval doesn't require comments
          status: APPROVED_STATUS,
        };

        console.log("[APPROVE] Sending:", mutationData);

        // Use executeAnyMutation directly
        const response = await generateAndExecuteMutation(
          "approveDeclineLeaveApplication", // mutation name
          mutationData, // variables
          "applicationsApprovals",
          base_url,
        );

        console.log("[APPROVE] Response:", response);

        if (
          response?.results ||
          (response && Object.values(response)[0] != null)
        ) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `${actions.actionName || "Item"} approved successfully.`,
          });
          setRefreshTable(true);
        } else {
          const errorMsg = response?.error ? JSON.parse(response.error) : null;
          throw new Error(errorMsg?.message || "Approval failed");
        }
      }
    } catch (error) {
      console.error("[APPROVE ERROR]", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text:
          error.message || "An error occurred while processing your request.",
      });
    }
  };

  const handleReject = async (row) => {
    try {
      const { value: reason } = await Swal.fire({
        title: "Reject Leave Application",
        text: `Do you want to reject this ${actions.actionName || "item"}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes, Reject it!`,
        cancelButtonText: "No, keep it",
        input: "textarea",
        inputPlaceholder: "Enter the reason for rejection",
        inputValidator: (value) => {
          if (!value) {
            return "You need to provide a reason for rejection!";
          }
        },
      });

      if (reason) {
        const decodedToken = JSON.parse(
          localStorage.getItem("decodedToken") || "{}",
        );
        const currentUserId = parseInt(decodedToken.Id) || null;
        const leaveApplicationId = row.applicationId ?? row.id;
        const REJECTED_STATUS = 2;

        if (!leaveApplicationId || !currentUserId) {
          throw new Error("Missing required data for rejection.");
        }

        // Build mutation data with rejection reason
        const mutationData = {
          applicationId: leaveApplicationId,
          userId: currentUserId,
          comments: reason, // rejection reason
          status: REJECTED_STATUS,
        };

        console.log("[REJECT] Sending:", mutationData);

        const response = await generateAndExecuteMutation(
          "approveDeclineLeaveApplication", // mutation name
          mutationData, // variables
          "applicationsApprovals",
          base_url,
        );

        console.log("[REJECT] Response:", response);

        if (
          response?.results ||
          (response && Object.values(response)[0] != null)
        ) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `${actions.actionName || "Item"} rejected successfully.`,
          });
          setRefreshTable(true);
        } else {
          const errorMsg = response?.error ? JSON.parse(response.error) : null;
          throw new Error(errorMsg?.message || "Rejection failed");
        }
      }
    } catch (error) {
      console.error("[REJECT ERROR]", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text:
          error.message || "An error occurred while processing your request.",
      });
    }
  };
  async function fetchData() {
    // Guard: if actions.dataObject is not defined, skip this fetcher.
    // Data loading will be handled by fetchAllData() via the `query` prop instead.
    if (!actions.dataObject) {
      return;
    }
    setLoading(true);
    try {
      const caseIdFromSession = JSON.parse(localStorage.getItem("CaseId"));
      let inputFields = "";
      if (actions.dataObject && actions.dataObject.inputFields) {
        inputFields = actions.dataObject.inputFields;
      } else {
        inputFields = {
          caseId: caseIdFromSession,
          isActive:
            actions.dataObject.inputObjectName === "allCaseTasksByColumnValues"
              ? 1 // Set isActive as 1 for "allCaseTasksByColumnValues"
              : true,
        };
      }

      if (actions.dataObject && !actions.dataObject.isDocumentUplod) {
        const data = await fetchDataEngine(
          actions.dataObject.inputObjectName,
          actions.dataObject.inputSubObjectName,
          inputFields,
          actions.dataObject.returnFields,
          base_url,
        );

        if (data) {
          setLoading(false);
          const sorted = applyDefaultSort(data);
          setData(sorted);
          setFilteredData(sorted);
        }
      } else if (actions.dataObject.isDocumentUplod) {
        inputFields = {
          caseId: caseIdFromSession,
        };
        const data = await fetchDataEngineCustomized(
          actions.dataObject.inputObjectName,
          actions.dataObject.inputSubObjectName,
          inputFields,
          actions.dataObject.returnFields,
          base_url,
        );
        if (data) {
          setLoading(false);
          const sorted = applyDefaultSort(data);
          setData(sorted);
          setFilteredData(sorted);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (hasDataObjectSource) {
      fetchData();
    }
  }, [hasDataObjectSource]);

  const handleRefresh = () => {
    if (hasDataObjectSource) {
      fetchData();
    } else {
      fetchAllData();
    }
  };
  // Helper to sort data using defaultSortModel.
  // Tries each field in order; falls back to id desc if the preferred field has no values.
  function applyDefaultSort(arr) {
    if (!arr || arr.length === 0) return arr;
    if (!defaultSortModel || defaultSortModel.length === 0) return arr;

    // Find the first field that actually has data in the array
    const { field: preferredField, sort: preferredSort } = defaultSortModel[0];
    const hasPreferredField = arr.some((row) => row[preferredField] != null);

    // If the preferred field (e.g. createdDate) has no data, fall back to id desc
    const field = hasPreferredField ? preferredField : "id";
    const sort = hasPreferredField ? preferredSort : "desc";

    return [...arr].sort((a, b) => {
      let va = a[field];
      let vb = b[field];
      // null/undefined always sink to bottom
      if (va == null && vb == null) return 0;
      if (va == null) return 1;
      if (vb == null) return -1;
      // try parse as date string
      const da = Date.parse(va);
      const db = Date.parse(vb);
      if (!isNaN(da) && !isNaN(db)) {
        va = da;
        vb = db;
      }
      if (va < vb) return sort === "desc" ? 1 : -1;
      if (va > vb) return sort === "desc" ? -1 : 1;
      return 0;
    });
  }

  async function fetchAllData() {
    try {
      setLoading(true);
      if (query && base_url) {
        const data = await graphqlQuery(query, base_url);
        if (data !== null) {
          setLoading(false);
          const sorted = applyDefaultSort(data);
          setData(sorted);
          setFilteredData(sorted);
        }
      } else {
        setLoading(false);
        const sorted = applyDefaultSort(DataFromGetBy);
        setData(sorted);
        setFilteredData(sorted);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (!hasDataObjectSource) {
      fetchAllData();
    }
  }, [query, base_url, hasDataObjectSource]);

  useEffect(() => {
    if (refreshTable === 0) return;

    if (hasDataObjectSource) {
      fetchData();
    } else {
      fetchAllData();
    }
    setRefreshTable(0);
  }, [refreshTable, hasDataObjectSource]);

  const filterActionsByRole = (action) => {
    if (actions[action]?.permission === "hasNoPermission") {
      return actions[action].roleGroupId?.includes(RoleGroupId);
    } else if (actions.isSubRight) {
      return hasSubRightPermission(actions.entity, actions[action]?.permission);
    } else {
      return hasPermission(actions.entity, actions[action]?.permission);
    }
  };
  const FILE_GATEWAY_URL = "https://api.sheriapro.sababisha.com";
  const FILE_STORAGE_API_KEY =
    "E3VF4C6KFV43JH6GKCDFGJP45V36JHGV3H4C6F3GJC63HG405GH6V345GHHJ4623FJJL3HCVMO1P23PZ07W8";

  // ...inside your switch(action)...
  // Handle view journal entries
  const handleViewJournalEntries = async (row) => {
    if (!actions.viewJournalEntries) return;

    setJournalModal({
      open: true,
      accountId: row.id,
      accountName: row.name || row.accountName || "Unknown", // Adjust based on your data
      journalData: [],
      loading: true,
    });

    try {
      const { query, inputFields, returnFields } = actions.viewJournalEntries;
      const response = await fetchDataEngine(
        query,
        "journalLines",
        inputFields(row),
        returnFields,
        accountsmanagement.uri,
      );

      if (response && Array.isArray(response)) {
        setJournalModal((prev) => ({
          ...prev,
          journalData: response,
          loading: false,
        }));
      } else {
        setJournalModal((prev) => ({
          ...prev,
          journalData: [],
          loading: false,
        }));
        Swal.fire("Info", "No journal entries found", "info");
      }
    } catch (error) {
      console.error("Error fetching journal entries:", error);
      Swal.fire("Error", "Failed to load journal entries", "error");
      setJournalModal((prev) => ({ ...prev, loading: false }));
    }
  };

  const columnsWithActions = [
    ...columns.map((column) => {
      const dateFields = [
        "initiateddate",
        "approveddate",
        "dateapproved",
        "dateofbirth",
        "createddate",
        "updateddate",
        "lastupdated",
        "expirydate",
        "stockduedate",
        "duedate",
        "actiondate",
        "nextbringup",
        "createdat",
        "yearofestablishment",
        "nextbringupdate",
        "resumptionDate",
        "endDate",
        "startDate",
      ];

      const amountFields = [
        // ✅ Payroll
        "totalAmount",
        "amountInBaseCurrency",
        "totalRequested",
        "refundAmount",
        "amountSpent",
        "amountRequested",
        "amount",
        "taxableAmount",
        "fixedAmount",
        "reliefAmount",
        "totalGross",
        "totalNet",
        "grossPay",
        "taxablePay",
        "totalEarnings",
        "totalDeductions",
        "netPay",
        "employerContributions",
        "upperBound",
        "lowerBound",

        // ✅ Accounts & Fixed Assets
        "basicSalary",
        "balance",
        "exchangeRate",
        "salvageValue",
        "purchaseCost",
        "currentValue",
        "disposalValue",
        "totalSpent",
        "accountBalance",
        "totalAmount",
      ];

      if (dateFields.includes(column.field.toLowerCase())) {
        return {
          ...column,
          renderCell: (params) => {
            const formatDate = (dateString) => {
              if (!dateString) return "";

              // Handle different date formats
              let date;

              // Try parsing as is first
              date = new Date(dateString);

              // If invalid, try parsing different formats
              if (isNaN(date.getTime())) {
                // Handle "dd/MM/yyyy" format (like "16/10/2025")
                if (dateString.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)) {
                  const [day, month, year] = dateString.split("/");
                  date = new Date(year, month - 1, day);
                }
                // Handle "MM/dd/yyyy HH:mm:ss" format (like "10/16/2025 19:50:54")
                else if (
                  dateString.match(
                    /^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{1,2}:\d{1,2}$/,
                  )
                ) {
                  const [datePart, timePart] = dateString.split(" ");
                  const [month, day, year] = datePart.split("/");
                  date = new Date(year, month - 1, day, ...timePart.split(":"));
                }
                // If still invalid, return original value
                else {
                  return dateString;
                }
              }

              // Check if date is valid before formatting
              if (isNaN(date.getTime())) {
                return dateString;
              }

              return format(date, "dd-MMM-yyyy");
            };

            const formattedDate = formatDate(params.value);

            return (
              <Box
                sx={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  lineHeight: "normal",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {formattedDate}
              </Box>
            );
          },
        };
      }
      if (column.field === "id") {
        return {
          ...column,
          wrapText: true, // Enable word wrap
          renderCell: (params) => params.api.getRowIndex(params.row.id) + 1,
        };
      }
      // Handle "done" column with "Done"/"Pending" labels
      if (column.field === "done") {
        return {
          ...column,
          renderCell: (params) =>
            params.value ? (
              <span
                style={{
                  color: "green",
                  fontWeight: "bold",
                }}
              >
                Done
              </span>
            ) : (
              <span
                style={{
                  color: "gray",
                  fontWeight: "bold",
                }}
              >
                Pending
              </span>
            ),
        };
      }
      if (
        amountFields.includes(column.field) ||
        column.field.toLowerCase().includes("amount") ||
        column.field.toLowerCase().includes("cost") ||
        column.field.toLowerCase().includes("value") ||
        column.field.toLowerCase().includes("price")
      ) {
        return {
          ...column,
          renderCell:
            column.renderCell ||
            ((params) =>
              params.value != null && params.value !== ""
                ? Number(params.value).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : "-"),
          valueFormatter: (params) =>
            params.value != null
              ? Number(params.value).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : "",
          align: "left",
          headerAlign: "left",
        };
      }
      if (column.field.toLowerCase().includes("isposted")) {
        return {
          ...column,
          renderCell: (params) => {
            const isPosted = params.value;

            return (
              <div
                style={{
                  backgroundColor: isPosted ? "#10b981" : "#ef4444",
                  color: "white",
                  padding: "3px 12px",
                  borderRadius: "10px",
                  fontSize: "12px",
                  textAlign: "center",
                  display: "inline-block",
                  textTransform: "lowercase",
                  letterSpacing: "0.5px",
                }}
              >
                {isPosted ? "Posted" : "Pending"}
              </div>
            );
          },
        };
      }
      if (/^is[A-Z_]/.test(column.field)) {
        return {
          ...column,
          renderCell: (params) => {
            const value = params.value;
            const fieldName = column.field.toLowerCase();

            // Define readable labels for specific fields
            const labelMap = {
              isposted: value ? "Posted" : "Pending",
              istaxable: value ? "Taxable" : "Non-Taxable",
              ispensionable: value ? "Pensionable" : "Non-Pensionable",
              isstatutory: value ? "Statutory" : "Non-Statutory",
              isrecurring: value ? "Recurring" : "One-Time",
              isOpen: value ? "Open" : "Closed",
            };

            const displayText = labelMap[fieldName] ?? (value ? "Yes" : "No");

            return (
              <div
                style={{
                  //backgroundColor: value ? "#10b981" : "#ef4444", // green/red
                  color: value ? "#10b981" : "#ef4444",
                  padding: "3px 10px",
                  borderRadius: "10px",
                  fontSize: "12px",
                  textAlign: "center",
                  display: "inline-block",
                  minWidth: "70px",
                  textTransform: "capitalize",
                }}
              >
                {displayText}
              </div>
            );
          },
        };
      }
      if (column.field.toLowerCase().includes("hasrelief")) {
        return {
          ...column,
          renderCell: (params) => {
            const value = params.value;
            const fieldName = column.field.toLowerCase();

            const labelMap = {
              hasrelief: value ? "Yes" : "No",
            };

            const displayText = labelMap[fieldName] ?? (value ? "Yes" : "No");

            return (
              <div
                style={{
                  color: value ? "#10b981" : "#ef4444",
                  padding: "3px 10px",
                  borderRadius: "10px",
                  fontSize: "12px",
                  textAlign: "center",
                  display: "inline-block",
                  minWidth: "70px",
                  textTransform: "capitalize",
                }}
              >
                {displayText}
              </div>
            );
          },
        };
      }

      if (column.field === "statusId") {
        return {
          ...column,
          renderCell: (params) => {
            const statusColors = {
              1: { text: "Pending", color: "#FF9800" },
              2: { text: "Pending", color: "#FF9800" },
              3: { text: "Approved", color: "#4CAF50" },
              4: { text: "Rejected", color: "#F44336" },
            };

            const status = statusColors[params.value] || {
              text: "Unknown",
              color: "#757575",
            };

            return (
              <span
                style={{
                  color: status.color,
                  textTransform: "capitalize",
                  fontSize: "0.85rem",
                }}
              >
                {status.text}
              </span>
            );
          },
        };
      }
      if (column.field === "dynamicProgressBringup") {
        return {
          ...column,
          renderCell: (params) => {
            const { activityType, actionTaken, outcome, nextStep } = params.row;
            if (activityType === "Court Attendance") {
              return outcome || "No outcome recorded";
            }
            if (activityType === "Bring Up") {
              return nextStep || "No remarks";
            }
            return actionTaken || "No description";
          },
        };
      }
      return {
        ...column,
        renderCell: (params) => (
          <Box
            sx={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              lineHeight: "normal",
              display: "flex",
              alignItems: "center",
            }}
          >
            {params.value}
          </Box>
        ),
      };
    }),
    ...(actions.showStatus !== true
      ? [
          {
            field: "isActive",
            headerName: "Status",
            flex: 0.5,
            renderCell: ({ row }) => {
              const isActive =
                row.isActive !== undefined ? row.isActive : row.active;

              const isActiveValue =
                isActive === true ||
                isActive === 1 ||
                isActive === "true" ||
                isActive === "1";

              return (
                <Typography
                  variant="body1"
                  style={{
                    color: isActiveValue ? "green" : "red",
                  }}
                >
                  {isActiveValue ? "Active" : "Inactive"}
                </Typography>
              );
            },
          },
        ]
      : []),

    {
      field: "actions",
      headerName: "Actions",
      flex: 2,
      renderCell: ({ row }) => {
        return (
          <Select
            value=""
            displayEmpty
            onChange={(e) => handleAction(e.target.value, row.id, row)}
            variant="outlined"
            IconComponent={(props) => (
              <span
                {...props}
                style={{ color: "#3b82f6", fontSize: "12px", right: "8px" }}
              >
                ▼
              </span>
            )}
            sx={{
              minWidth: 100,
              height: 32,
              backgroundColor: "#eff6ff",
              border: "1px solid #3b82f6",
              borderRadius: "6px",
              color: "#3b82f6",
              fontWeight: 600,
              fontSize: "13px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&:hover": {
                backgroundColor: "#8caedaff",
                transform: "translateY(-1px)",
                boxShadow: "0 2px 4px rgba(59, 130, 246, 0.2)",
              },
              "&.Mui-focused": {
                backgroundColor: "#dbeafe",
                boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)",
              },
              "& .MuiSelect-select": {
                paddingTop: "6px",
                paddingBottom: "6px",
                paddingLeft: "10px",
                paddingRight: "32px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              },
            }}
            renderValue={(value) => (
              <div
                style={{ display: "flex", alignItems: "center", gap: "4px" }}
              >
                <span style={{ fontSize: "14px" }}>⚡</span>
                <span>Actions</span>
              </div>
            )}
          >
            <MenuItem value="" disabled>
              <em style={{ color: "#6b7280" }}>Select an action</em>
            </MenuItem>
            {(Object.keys(actions || {}) || [])
              .filter(
                (action) =>
                  action !== "add" &&
                  actions[action]?.Show_Button &&
                  filterActionsByRole(action),
              )
              .map((action) => {
                if (action === "activateDeactivate") {
                  const activeField =
                    row.isActive !== undefined ? "isActive" : "active";

                  const activeValue =
                    row.isActive !== undefined ? row.isActive : row.active;

                  const isActive =
                    activeValue === true ||
                    activeValue === 1 ||
                    activeValue === "true" ||
                    activeValue === "1";

                  return (
                    <MenuItem
                      key={action}
                      value={action}
                      onClick={() =>
                        handleActivateDeactivate(
                          activeValue,
                          row.id,
                          activeField,
                        )
                      }
                      sx={{
                        color: isActive ? "#ef4444" : "#10b981",
                        "&:hover": {
                          backgroundColor:
                            theme.palette.mode === "light"
                              ? "#e3f2fd"
                              : isActive
                                ? "#091d4aff"
                                : "#1b145bff",
                        },
                      }}
                    >
                      <span style={{ marginRight: "8px" }}>
                        {isActive ? "🔴" : "🟢"}
                      </span>

                      {isActive ? "Deactivate" : "Activate"}
                    </MenuItem>
                  );
                }
                const approvalActions = [
                  // "edit",
                  "approve",
                  "decline",
                  "approveFeeNote",
                  "approveProformaFeeNote",
                  "approveClientReceipt",
                  "approvePurchaseInvoice",
                  "approvePV",
                  "approveCreditNote",
                ];

                // ✅ Universal check for approved/posted items
                const isAlreadyApprovedOrPosted =
                  row.statusId === 3 || // for numeric status systems
                  row.statusDescription === "Approved" || // for text-based statuses
                  row.statusDescription === "Declined" ||
                  row.status === "Approved" ||
                  row.isPosted === true || // for boolean posted systems
                  row.statusName === "Posted" || // alternative naming
                  row.Stage === "Approved" ||
                  row.Stage === "posted" ||
                  row.isPosted === 1 ||
                  (typeof row.status === "string" &&
                    row.status.toLowerCase() === "posted"); // if status is a string "Posted"

                return (
                  actions[action] &&
                  (() => {
                    // Edit should be disabled (but still visible) when row is approved
                    const isEditDisabled =
                      action === "edit" &&
                      (row.statusDescription === "Approved" ||
                        row.status === "Approved" ||
                        row.Stage === "Approved");

                    const isApprovalDisabled =
                      approvalActions.includes(action) &&
                      isAlreadyApprovedOrPosted;

                    return (
                      <MenuItem
                        key={actions[action].key}
                        value={action}
                        disabled={isEditDisabled || isApprovalDisabled}
                        onClick={() => {
                          if (isEditDisabled || isApprovalDisabled) return;
                          handleAction(action, row.id, row);
                        }}
                        sx={{
                          opacity: isEditDisabled ? 0.5 : 1,
                          cursor: isEditDisabled ? "not-allowed" : "pointer",
                          "&:hover": {
                            backgroundColor:
                              isEditDisabled || isApprovalDisabled
                                ? "transparent"
                                : theme.palette.mode === "light"
                                  ? "#e3f2fd"
                                  : "#1b145bff",
                          },
                        }}
                      >
                        <span style={{ marginRight: "8px" }}>
                          {isEditDisabled
                            ? "🔒"
                            : approvalActions.includes(action) &&
                                isAlreadyApprovedOrPosted
                              ? "✅"
                              : action === "viewJournalEntries"
                                ? "📊"
                                : "📝"}
                        </span>
                        {isEditDisabled
                          ? "Edit (Approved)"
                          : approvalActions.includes(action) &&
                              isAlreadyApprovedOrPosted
                            ? "Approved"
                            : actions[action].button_name}
                      </MenuItem>
                    );
                  })()
                );
              })}
          </Select>
        );
      },
    },
  ];

  const handleAdd = () => {
    setIsEditing(false);
    setEditData(null);
    if (isMobile) {
      setDialogOpen(true);
    } else {
      setDrawerOpen(true);
    }
  };
  const handleOpenTaskModal = (id) => {
    const itemToEdit = data.find((item) => item.id === id);
    setTaskModalOpen(true);
    setEditData(itemToEdit);
  };
  const handleOpenEngagementLetterModal = (row) => {
    setEngagementLetterModalOpen(true);
    setEditData(row);
  };
  const handleOpenCourtAttendanceSheetModal = (row) => {
    setCourtAttendanceSheetModalOpen(true);
    setEditData(row);
  };
  const handleOpenUpdateCaseStatusModal = (id) => {
    const itemToEdit = data.find((item) => item.id === id);
    setUpdateCaseStatusModalOpen(true);
    setEditData(itemToEdit);
  };
  const handleAssignDocumentAccessModal = (id) => {
    const itemToEdit = data.find((item) => item.id === id);
    setAssignDocumentAccessOpen(true);
    setEditData(itemToEdit);
  };
  const handleEdit = (id) => {
    const itemToEdit = data.find((item) => item.id === id);
    setEditData(itemToEdit);
    setIsEditing(true);
    if (isMobile) {
      setDialogOpen(true);
    } else {
      setDrawerOpen(true);
    }
  };

  const handleAction = async (action, id, row) => {
    const actionConfig = actions[action];
    console.log("Action triggered:", action, id, row);

    if (
      actions[action]?.onClick &&
      typeof actions[action].onClick === "function"
    ) {
      actions[action].onClick(row, () => setRefreshTable((prev) => !prev));
      return;
    }
    // Print cases
    if (action === "PrintFeeNote") {
      await handlePrintFeeNote(row);
      return;
    }
    if (action === "PrintProformaNote") {
      await handlePrintProformaNote(row);
      return;
    }
    if (action === "PrintCreditNote") {
      await handlePrintCreditNote(row);
      return;
    }
    if (action === "PrintReceipt") {
      await handlePrintReceipt(row);
      return;
    }
    if (action === "PrintInvoice") {
      await handlePrintInvoice(row);
      return;
    }
    if (action === "PrintPayslip") {
      await handlePrintPayslip(row);
      return;
    }
    if (action === "PrintEmployeePayslip") {
      // **NEW** – open modal instead of fetching immediately
      openPayrollRunModal(row);
      return;
    }
    if (action === "PrintVoucher") {
      await handlePrintVoucher(row);
      return;
    }

    if (action === "print") {
      handlePrint(row);
      return;
    }
    if (action === "approveFeeNote") {
      await handleApproveFeeNote(row);
      return;
    }
    if (action === "sendForapprovalFeeNote") {
      await handlePendingFeeNote(row);
      return;
    }
    if (action === "sendForapprovalImprest") {
      await handlePendingImprest(row);
      return;
    }
    if (action === "sendForapprovalPayrollRun") {
      await handlePendingPayrollRun(row);
      return;
    }
    if (action === "sendForapprovalStaffClaim") {
      await handlePendingStaffClaim(row);
      return;
    }

    if (action === "approveProformaNote") {
      await handleApproveProformaNote(row);
      return;
    }
    if (action === "approveCreditNote") {
      await handleApproveCreditNote(row);
      return;
    }
    // Print cases
    if (action === "PrintFeeNote") {
      await handlePrintFeeNote(row);
      return;
    }
    if (action === "PrintProformaNote") {
      await handlePrintProformaNote(row);
      return;
    }
    if (action === "PrintCreditNote") {
      await handlePrintCreditNote(row);
      return;
    }
    if (action === "PrintReceipt") {
      await handlePrintReceipt(row);
      return;
    }
    if (action === "PrintInvoice") {
      await handlePrintInvoice(row);
      return;
    }
    if (action === "PrintPayslip") {
      await handlePrintPayslip(row);
      return;
    }
    if (action === "PrintEmployeePayslip") {
      // **NEW** – open modal instead of fetching immediately
      openPayrollRunModal(row);
      return;
    }
    if (action === "PrintVoucher") {
      await handlePrintVoucher(row);
      return;
    }

    if (action === "print") {
      handlePrint(row);
      return;
    }
    if (action === "approveFeeNote") {
      await handleApproveFeeNote(row);
      return;
    }

    if (action === "approveProformaNote") {
      await handleApproveProformaNote(row);
      return;
    }
    if (action === "approveCreditNote") {
      await handleApproveCreditNote(row);
      return;
    }

    if (
      actions[action]?.onClick &&
      typeof actions[action].onClick === "function"
    ) {
      actions[action].onClick(row, () => setRefreshTable((prev) => !prev));
      return;
    }
    // Print cases
    if (action === "PrintFeeNote") {
      await handlePrintFeeNote(row);
      return;
    }
    if (action === "PrintProformaNote") {
      await handlePrintProformaNote(row);
      return;
    }
    if (action === "PrintCreditNote") {
      await handlePrintCreditNote(row);
      return;
    }
    if (action === "PrintReceipt") {
      await handlePrintReceipt(row);
      return;
    }
    if (action === "PrintInvoice") {
      await handlePrintInvoice(row);
      return;
    }
    if (action === "PrintPayslip") {
      await handlePrintPayslip(row);
      return;
    }
    if (action === "PrintEmployeePayslip") {
      // **NEW** – open modal instead of fetching immediately
      openPayrollRunModal(row);
      return;
    }
    if (action === "PrintVoucher") {
      await handlePrintVoucher(row);
      return;
    }

    if (action === "print") {
      handlePrint(row);
      return;
    }
    if (action === "approveFeeNote") {
      await handleApproveFeeNote(row);
      return;
    }

    if (action === "approveProformaNote") {
      await handleApproveProformaNote(row);
      return;
    }
    if (action === "approveCreditNote") {
      await handleApproveCreditNote(row);
      return;
    }
    switch (action) {
      case "edit":
        handleEdit(id);
        break;
      case "viewJournalEntries":
        await handleViewJournalEntries(row);
        break;
      case "approvePV":
        handleApprovePV(row);
        break;
      case "ViewVoucherLines":
        setSelectedPaymentForLines(row);
        setPaymentLinesDialogOpen(true);

        break;
      case "APPROVEIMPREST":
        await handleApproveImprest(row);
        break;

      case "REJECTIMPREST":
        await handleRejectImprest(row);
        break;

      case "APPROVEPAYROLL":
        await handleApprovePayroll(row);
        break;
      case "RUNPAYROLL":
        await handleRunPayroll(row);
        break;
      case "POSTPAYROLL":
        await handlePostPayroll(row);
        break;
      case "CLOSEPAYROLL":
        await handleClosePayroll(row);
        break;

      case "APPROVEIMPRESTSURRENDER":
        await handleApproveImprestSurrender(row);
        break;

      case "REJECTIMPRESTSURRENDER":
        await handleRejectImprestSurrender(row);
        break;

      case "APPROVECLAIM":
        await handleApproveClaim(row);
        break;

      case "REJECTCLAIM":
        await handleRejectClaim(row);
        break;
      case "ViewRelievers":
        setSelectedLeaveApplicationForRelievers(row);
        setRelieversDialogOpen(true);
        break;
      case "ViewImprestLines":
        setSelectedImprestForLines(row);
        setImprestLinesDialogOpen(true);
        break;
      case "ViewClaimLines":
        setSelectedClaimForLines(row);
        setClaimLinesDialogOpen(true);
        break;
      case "ViewSurrenderLineByApplication":
        setSelectedSurrenderForLines(row);
        setSurrenderLinesDialogOpen(true);
        break;
      case "ViewPayrollLines":
        localStorage.setItem("PayrollData", JSON.stringify(row));
        navigate("/payrollrun-lines");
        break;
      case "DISBURSEIMPREST":
        setDisburseRow(row);
        setDisburseImprestOpen(true);
        break;
      case "ViewPayrollLinesDetails":
        openPayrollLineDetails(row);
        break;
      case "DISBURSECLAIM":
        setDisburseRow(row);
        setDisburseClaimOpen(true);
        break;
      case "ViewProformaLines":
        localStorage.setItem("MyProformaFeeNoteData", JSON.stringify(row));
        navigate("/proforma-fee-note-lines");
        break;
      case "approveProformaFeeNote":
        handleApproveProformaNote(row);
        // case "approvereceipt":
        //   handleApproveClientReceipt(row);

        break;
      case "ViewFeeNoteLines":
        localStorage.setItem("MyFeeNoteData", JSON.stringify(row));
        navigate("/fee-note-lines");
        break;
      case "VIEWCURRENCYLINES":
        localStorage.setItem("CurrencyData", JSON.stringify(row));
        navigate("/currency-lines");
        break;
      case "ViewStatutoryLines":
        setSelectedStatutoryForRates(row);
        setStatutoryRatesDialogOpen(true);
        break;
      case "ViewCreditNoteLines":
        localStorage.setItem("MyCreditNoteData", JSON.stringify(row));
        navigate("/credit-note-lines");
        break;
      case "ViewClientReceiptLines":
        localStorage.setItem("MyClientReceiptData", JSON.stringify(row));
        navigate("/client-receipt-lines");
        break;
      case "approveClientReceipt":
        handleApproveClientReceipt(row);

        break;
      case "ViewPurchaseInvoiceLines":
        // localStorage.setItem("MyPurchaseInvoiceData", JSON.stringify(row));
        // navigate("/purchase-invoice-lines");
        setSelectedPurchaseForLines(row);
        setPurchaseLinesDialogOpen(true);
        break;
      case "approvePurchaseInvoice":
        handleApprovePurchaseInvoice(row);

        break;
      case "add":
        handleAdd();
        break;
      case "documentAccess":
        handleAssignDocumentAccessModal(id);
        break;
      case "ViewCorporateClientCases":
        localStorage.setItem("CorporateclientData", JSON.stringify(row));
        navigate("/Corporate-Client-Cases");
        break;
      case "ViewIndividualClientCases":
        localStorage.setItem("IndividualclientData", JSON.stringify(row));
        navigate("/Individual-Client-Cases");
        break;
      case "ViewCase":
        localStorage.setItem("CaseId", JSON.stringify(id));
        localStorage.setItem("ClientId", JSON.stringify(row.clientId));
        localStorage.setItem("fileNumber", JSON.stringify(row.fileNumber));
        navigate("/case-details");
        break;
      case "ViewEmployeeDetails":
        setSelectedEmployeeForPayStructure(row);
        setEmployeePayDialogOpen(true);
        break;
      case "AssignTask":
        handleOpenTaskModal(id);
        break;
      case "EngagementLetter":
        handleOpenEngagementLetterModal(row);
        break;
      case "CourtAttendanceSheet":
        handleOpenCourtAttendanceSheetModal(row);
        break;
      case "updateCaseStatus":
        handleOpenUpdateCaseStatusModal(id);
        break;
      case "deleteDocument":
        handleDeleteDocument(row.filePath, id);
        break;
      case "approve":
        handleApprove(row);
        break;
      case "ViewSurrenderLineByApplication":
        localStorage.setItem("SurrenderId", JSON.stringify(row));
        navigate("/imprest-Surrender-Lines");
        break;
      case "viewStaffClaimsLines":
        localStorage.setItem("claimApplicationId", JSON.stringify(row));
        navigate("/staff-claim-Lines");
        break;
      case "decline":
        handleReject(row);
        break;
      case "markTask":
        await handleMarkTaskDone(id);
        break;
      case "removeLeaveApprover":
        await removeLeaveApprover(row);
        break;
      case "removeSurrenderLine":
        await removeSurrenderLine(row);
        break;
      case "submit":
        await handleSubmit(id);
        break;
      case "RemoveItem":
        await handleRemoveTeamMember(row);
        break;
      // case "activateDeactivate":
      //   handleActivateDeactivate(row.isActive, row.id);
      // break;
      // case "viewDocument":
      //   const filePath = `${base_file_path}&documentId=${row?.id}&file=${row?.filePath}`;
      //   const actionKey = "UPDATE_ACTIVE_DOCUMENT";
      //   dispatch(UpdateDataToStore(actionKey, filePath));
      //   break;
      case "viewDocument":
        (async () => {
          try {
            if (row?.filePath) {
              const res = await fetch(
                `${FILE_GATEWAY_URL}/filestorageservice/presigned-url?objectName=${encodeURIComponent(row.filePath)}&expiry=3600`,
                {
                  method: "GET",
                  headers: { "X-Api-Key": FILE_STORAGE_API_KEY },
                },
              );

              if (!res.ok) {
                throw new Error(
                  `Failed to get presigned URL (Status: ${res.status})`,
                );
              }

              const data = await res.json();
              if (!data?.url)
                throw new Error("No URL returned from file gateway");

              dispatch(UpdateDataToStore("UPDATE_ACTIVE_DOCUMENT", data.url));
            }
            // else if (row?.filePath) {
            //   // legacy documents that were never migrated to MinIO
            //   const filePath = `${base_file_path}&documentId=${row?.id}&file=${row?.filePath}`;
            //    dispatch(UpdateDataToStore("UPDATE_ACTIVE_DOCUMENT", filePath));
            // }
            else {
              throw new Error("No valid storage path found for this document.");
            }
          } catch (err) {
            console.error("Could not open document", err);
            Swal.fire({
              icon: "error",
              title: "Could not open document",
              text: "Please check your network connection and try again.",
            });
          }
        })();
        break;
      //     case "viewDocument":
      // (async () => {
      //   try {
      //     const token = localStorage.getItem("token");
      //     const res = await fetch(
      //       `${documentUploadUrl.uri4}/GetCaseDocumentUrl?documentId=${row.id}`,
      //       { headers: { Authorization: `Bearer ${token.replace(/"/g, "")}` } }
      //     );
      //     const data = await res.json();

      //     if (data.legacy) {
      //       // old encrypted-on-disk documents keep using the existing flow
      //       const filePath = `${base_file_path}&documentId=${row?.id}&file=${row?.filePath}`;
      //       dispatch(UpdateDataToStore("UPDATE_ACTIVE_DOCUMENT", filePath));
      //     } else {
      //       dispatch(UpdateDataToStore("UPDATE_ACTIVE_DOCUMENT", data.url));
      //     }
      //   } catch (err) {
      //     console.error("Could not open document", err);
      //   }
      // })();
      // break;
      default:
        break;
    }
  };
  // Update the print handler functions
  const handlePrintFeeNote = async (row) => {
    try {
      setPrintData([row]);
      setPrintComponent("FeeNote"); // Set which component to render
      setPrintOpen(true);
    } catch (error) {
      console.error("Error preparing print:", error);
      Swal.fire({
        icon: "error",
        title: "Print Error",
        text: "Failed to prepare document for printing",
      });
    }
  };

  const handlePrintProformaNote = async (row) => {
    try {
      setPrintData([row]);
      setPrintComponent("ProformaNote"); // Set which component to render
      setPrintOpen(true); // Use the proforma-specific state
    } catch (error) {
      console.error("Error preparing print:", error);
      Swal.fire({
        icon: "error",
        title: "Print Error",
        text: "Failed to prepare document for printing",
      });
    }
  };
  const handlePrintCreditNote = async (row) => {
    try {
      setPrintData([row]);
      setPrintComponent("CreditNote"); // Set which component to render
      setPrintOpen(true); // Use the proforma-specific state
    } catch (error) {
      console.error("Error preparing print:", error);
      Swal.fire({
        icon: "error",
        title: "Print Error",
        text: "Failed to prepare document for printing",
      });
    }
  };
  const handlePrintReceipt = async (row) => {
    try {
      setPrintData([row]);
      setPrintComponent("ClientReceipt"); // Set which component to render
      setPrintOpen(true); // Use the proforma-specific state
    } catch (error) {
      console.error("Error preparing print:", error);
      Swal.fire({
        icon: "error",
        title: "Print Error",
        text: "Failed to prepare document for printing",
      });
    }
  };
  const handlePrintInvoice = async (row) => {
    try {
      setPrintData([row]);
      setPrintComponent("PrintInvoice"); // Set which component to render
      setPrintOpen(true); // Use the proforma-specific state
    } catch (error) {
      console.error("Error preparing print:", error);
      Swal.fire({
        icon: "error",
        title: "Print Error",
        text: "Failed to prepare document for printing",
      });
    }
  };

  const openPayrollRunModal = (row) => {
    setPendingEmployeeId(row.id);
    setPayrollRunModalOpen(true);
  };
  const fetchPayslipAndPrint = async (payrollRunId) => {
    if (!pendingEmployeeId || !payrollRunId) return;

    try {
      const payslipQuery = `
      query Payslip {
        payslip(employeeId: ${pendingEmployeeId}, payrollRunId: ${payrollRunId}) {
          employeeName
          kraPin
          nssf
          nhif
          grossPay
          netPay
          payDate
          periodStart
          periodEnd
          earnings { name amount }
          taxComputation { name amount }
          deductions { name amount isStatutory }
          employerContributions { name employerAmount }
        }
      }
    `;

      const response = await graphqlQuery(
        payslipQuery,
        "https://matrix.mcb.co.ke/gateway/HRService",
      );

      const payslipData = response;

      if (!payslipData) {
        throw new Error("No payslip data returned");
      }

      // Set print data
      setPrintData([payslipData]);
      setPrintComponent("PrintPayslip");
      setPrintOpen(true);
    } catch (error) {
      console.error("Print Payslip Error:", error);
      Swal.fire({
        icon: "error",
        title: "Print Failed",
        text: error.message || "Could not load payslip",
      });
    } finally {
      setPendingEmployeeId(null);
    }
  };
  const handlePrintPayslip = async (row) => {
    try {
      const employeeId = row.employeeId;
      const payrollRunId = row.payrollRunId;

      if (!employeeId || !payrollRunId) {
        throw new Error("Missing employeeId or payrollRunId");
      }

      // GraphQL Query
      const payslipQuery = `
      query Payslip {
        payslip(employeeId: ${employeeId}, payrollRunId: ${payrollRunId}) {
          employeeName
          kraPin
          nssf
          nhif
          grossPay
          netPay
          payDate
          periodStart
          periodEnd
          earnings { name amount }
          taxComputation { name amount }
          deductions { name amount isStatutory }
          employerContributions { name employerAmount }
        }
      }
    `;

      const response = await graphqlQuery(
        payslipQuery,
        "https://matrix.mcb.co.ke/gateway/HRService",
      );

      const payslipData = response;

      if (!payslipData) {
        throw new Error("No payslip data returned");
      }

      // Set print data
      setPrintData([payslipData]);
      setPrintComponent("PrintPayslip");
      setPrintOpen(true);
    } catch (error) {
      console.error("Print Payslip Error:", error);
      Swal.fire({
        icon: "error",
        title: "Print Failed",
        text: error.message || "Could not load payslip",
      });
    }
  };
  const handlePrintVoucher = async (row) => {
    try {
      setPrintData([row]);
      setPrintComponent("PrintVoucher"); // Set which component to render
      setPrintOpen(true); // Use the proforma-specific state
    } catch (error) {
      console.error("Error preparing print:", error);
      Swal.fire({
        icon: "error",
        title: "Print Error",
        text: "Failed to prepare document for printing",
      });
    }
  };
  const handlePrint = (row = null) => {
    if (row) {
      setPrintData([row]);
    } else {
      setPrintData(data || []);
    }
    setPrintOpen(true);
  };

  const handleSearch = (input) => {
    setSearchTerm(input);

    if (input.trim() !== "") {
      const searchLower = input.toLowerCase();

      const filtered = data.filter((row) => {
        return columns.some((column) => {
          const cellValue = row[column.field];

          if (cellValue == null) return false;

          // Handle dates
          if (column.field.toLowerCase().includes("date")) {
            try {
              const formattedDate = format(new Date(cellValue), "dd-MMM-yyyy");
              return formattedDate.toLowerCase().includes(searchLower);
            } catch {
              // If date parsing fails, continue to string search
            }
          }

          // Handle numbers (like amounts, IDs)
          if (typeof cellValue === "number") {
            return String(cellValue).includes(input);
          }

          // Handle strings
          return String(cellValue).toLowerCase().includes(searchLower);
        });
      });

      setFilteredData(filtered);
    } else {
      setFilteredData(data); // Reset to original data
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Enhanced Header Section */}
      <Card
        elevation={0}
        sx={{
          mb: 3,
          background:
            theme.palette.mode === "light"
              ? "#ecf0f3"
              : `linear-gradient(135deg, ${colors.primary[400]} 0%, ${colors.primary[500]} 100%)`,
          borderRadius: "16px",
          overflow: "visible",
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={2}
            alignItems={{ xs: "stretch", md: "center" }}
            justifyContent="space-between"
          >
            {/* Title Section */}
            <Box>
              <Typography
                variant="h4"
                fontWeight="700"
                sx={{
                  color: colors.grey[100],
                  mb: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {title}
                <Chip
                  label={`${filteredData?.length || 0} records`}
                  size="small"
                  sx={{
                    backgroundColor: colors.greenAccent[600],
                    color: "white",
                    fontWeight: 600,
                  }}
                />
              </Typography>
              <Typography variant="body2" sx={{ color: colors.grey[300] }}>
                {subtitle}
              </Typography>
            </Box>

            {/* Action Buttons */}
            <Stack direction="row" spacing={1.5}>
              <Tooltip title="Refresh data" arrow>
                <IconButton
                  onClick={handleRefresh}
                  sx={{
                    backgroundColor:
                      theme.palette.mode === "light"
                        ? "#ffffff"
                        : colors.primary[300],
                    color:
                      theme.palette.mode === "light"
                        ? "#1766A2"
                        : colors.grey[100],
                    border:
                      theme.palette.mode === "light"
                        ? `1px solid #d9e2e8`
                        : "none",
                    "&:hover": {
                      backgroundColor:
                        theme.palette.mode === "light"
                          ? "#e3f2fd"
                          : colors.primary[200],
                      transform: "rotate(180deg)",
                      transition: "transform 0.3s ease",
                    },
                  }}
                >
                  <RefreshIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Export data" arrow>
                <IconButton
                  sx={{
                    backgroundColor:
                      theme.palette.mode === "light"
                        ? "#ffffff"
                        : colors.primary[300],
                    color:
                      theme.palette.mode === "light"
                        ? "#1766A2"
                        : colors.grey[100],
                    border:
                      theme.palette.mode === "light"
                        ? `1px solid #d9e2e8`
                        : "none",
                    "&:hover": {
                      backgroundColor:
                        theme.palette.mode === "light"
                          ? "#e3f2fd"
                          : colors.primary[200],
                    },
                  }}
                >
                  <DownloadIcon />
                </IconButton>
              </Tooltip>

              {actions.add &&
                actions.add.Show_Button &&
                filterActionsByRole("add") && (
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => handleAction("add")}
                    sx={{
                      backgroundColor: colors.greenAccent[500],
                      color: colors.primary[900],
                      fontWeight: 600,
                      borderRadius: "10px",
                      px: 3,
                      textTransform: "none",
                      boxShadow: `0 4px 14px ${colors.greenAccent[700]}`,
                      "&:hover": {
                        backgroundColor: colors.greenAccent[400],
                        transform: "translateY(-2px)",
                        boxShadow: `0 6px 20px ${colors.greenAccent[700]}`,
                      },
                      transition: "all 0.2s ease",
                    }}
                  >
                    {actions.add.button_name}
                  </Button>
                )}
            </Stack>
          </Stack>
        </CardContent>
      </Card>

      {/* Search and Filter Bar */}
      <Card
        elevation={0}
        sx={{
          mb: 2,
          borderRadius: "12px",
          border: `1px solid ${colors.primary[300]}`,
        }}
      >
        <CardContent sx={{ p: 2 }}>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            alignItems="center"
          >
            {/* Enhanced Search Field */}
            <TextField
              fullWidth
              variant="outlined"
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
              placeholder={`Search ${title}...`}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  backgroundColor:
                    theme.palette.mode === "light"
                      ? "#ffffff"
                      : colors.primary[400],
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor:
                      theme.palette.mode === "light"
                        ? "#e3f2fd"
                        : colors.primary[300],
                  },
                  "&.Mui-focused": {
                    backgroundColor:
                      theme.palette.mode === "light"
                        ? "#ffffff"
                        : colors.primary[300],
                    boxShadow:
                      theme.palette.mode === "light"
                        ? "0 0 0 3px rgba(23, 102, 162, 0.2)"
                        : `0 0 0 3px ${colors.blueAccent[700]}30`,
                  },
                  "& fieldset": {
                    borderColor:
                      theme.palette.mode === "light"
                        ? "#d9e2e8"
                        : colors.primary[300],
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: colors.grey[300] }} />
                  </InputAdornment>
                ),
                endAdornment: searchTerm && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => setSearchTerm("")}
                      sx={{ color: colors.grey[300] }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* Filter Button */}
            <Tooltip title="Advanced filters" arrow>
              <IconButton
                onClick={(e) => setFilterAnchor(e.currentTarget)}
                sx={{
                  backgroundColor:
                    theme.palette.mode === "light"
                      ? "#ffffff"
                      : colors.primary[400],
                  border: `1px solid ${theme.palette.mode === "light" ? "#d9e2e8" : colors.primary[300]}`,
                  borderRadius: "12px",
                  px: 2,
                  "&:hover": {
                    backgroundColor:
                      theme.palette.mode === "light"
                        ? "#e3f2fd"
                        : colors.primary[300],
                  },
                }}
              >
                <FilterListIcon />
              </IconButton>
            </Tooltip>

            {/* Column Visibility */}
            <Tooltip title="Manage columns" arrow>
              <IconButton
                sx={{
                  backgroundColor: colors.primary[400],
                  border: `1px solid ${colors.primary[300]}`,
                  borderRadius: "12px",
                  px: 2,
                  "&:hover": {
                    backgroundColor: colors.primary[300],
                  },
                }}
              >
                <ViewColumnIcon />
              </IconButton>
            </Tooltip>
          </Stack>

          {/* Selected Rows Info */}
          {selectedRows.length > 0 && (
            <Fade in>
              <Box
                sx={{
                  mt: 2,
                  p: 1.5,
                  backgroundColor: colors.blueAccent[800],
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="body2" sx={{ color: colors.grey[100] }}>
                  <strong>{selectedRows.length}</strong> row(s) selected
                </Typography>
                <Button
                  size="small"
                  onClick={() => setSelectedRows([])}
                  sx={{ color: colors.grey[100] }}
                >
                  Clear selection
                </Button>
              </Box>
            </Fade>
          )}
        </CardContent>
      </Card>

      {/* Enhanced DataGrid */}
      <Card
        elevation={0}
        sx={{
          borderRadius: "12px",
          border: `1px solid ${colors.primary[300]}`,
          overflow: "hidden",
        }}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <CircularProgress
              size={48}
              sx={{ color: colors.greenAccent[500] }}
            />
            <Typography variant="body1" sx={{ color: colors.grey[300] }}>
              Loading data...
            </Typography>
          </Box>
        ) : filteredData?.length === 0 ? (
          // Empty State
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 120,
                height: 120,
                borderRadius: "50%",
                backgroundColor: colors.primary[400],
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
              }}
            >
              <SearchIcon sx={{ fontSize: 60, color: colors.grey[500] }} />
            </Box>
            <Typography
              variant="h5"
              sx={{ color: colors.grey[100], fontWeight: 600 }}
            >
              No data found
            </Typography>
            <Typography variant="body2" sx={{ color: colors.grey[300], mb: 2 }}>
              {searchTerm
                ? "Try adjusting your search or filters"
                : "Get started by adding your first record"}
            </Typography>
            {actions.add && actions.add.Show_Button && (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => handleAction("add")}
                sx={{
                  backgroundColor: colors.greenAccent[500],
                  color: colors.primary[900],
                }}
              >
                {actions.add.button_name}
              </Button>
            )}
          </Box>
        ) : (
          <Box sx={{ height: "90vh" }}>
            <DataGrid
              checkboxSelection
              rows={filteredData || []}
              columns={columnsWithActions}
              components={{ Toolbar: GridToolbar }}
              getRowId={getRowId}
              density={density}
              initialState={{
                sorting: {
                  sortModel: defaultSortModel || [
                    { field: "createdDate", sort: "desc" },
                  ],
                },
              }}
              onSelectionModelChange={(newSelection) =>
                setSelectedRows(newSelection)
              }
              sx={{
                border: "none",
                "& .MuiDataGrid-root": {
                  border: "none",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: `1px solid ${theme.palette.mode === "light" ? "#e0e4e7" : colors.primary[300]}`,
                  borderRight: "none",
                  color: theme.palette.mode === "light" ? "#1a1a2e" : undefined,
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor:
                    theme.palette.mode === "light"
                      ? "#ecf0f3"
                      : colors.primary[400],
                  borderBottom: `2px solid ${theme.palette.mode === "light" ? "#d9e2e8" : colors.primary[300]}`,
                  fontSize: "12px",
                  fontWeight: 700,
                  color:
                    theme.palette.mode === "light"
                      ? "#1F2A40"
                      : colors.grey[100],
                },
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor:
                    theme.palette.mode === "light"
                      ? "#ffffff"
                      : colors.primary[500],
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: `2px solid ${theme.palette.mode === "light" ? "#d9e2e8" : colors.primary[300]}`,
                  backgroundColor:
                    theme.palette.mode === "light"
                      ? "#ecf0f3"
                      : colors.primary[400],
                },
                "& .MuiDataGrid-row": {
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor:
                      theme.palette.mode === "light"
                        ? "#f0f4f8"
                        : colors.primary[400],
                    transform: "scale(1.001)",
                    boxShadow:
                      theme.palette.mode === "light"
                        ? "0 2px 8px rgba(31,118,173,0.10)"
                        : `0 2px 8px ${colors.primary[900]}30`,
                  },
                },
                "& .MuiCheckbox-root": {
                  color:
                    theme.palette.mode === "light"
                      ? "#1766A2"
                      : colors.grey[400],
                  "&.Mui-checked": {
                    color: colors.greenAccent[500],
                  },
                },
                "& .MuiDataGrid-toolbarContainer": {
                  padding: "16px",
                  backgroundColor:
                    theme.palette.mode === "light"
                      ? "#ecf0f3"
                      : colors.primary[400],
                  borderBottom: `1px solid ${theme.palette.mode === "light" ? "#d9e2e8" : colors.primary[300]}`,
                  "& .MuiButton-text": {
                    color:
                      theme.palette.mode === "light"
                        ? "#1766A2"
                        : colors.grey[100],
                    fontWeight: 600,
                  },
                },
              }}
            />
          </Box>
        )}
      </Card>
      {/* Print Dialog */}
      <Dialog
        open={printOpen}
        onClose={() => setPrintOpen(false)}
        maxWidth="lg"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            minHeight: "80vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          {printComponent === "FeeNote" && <PrintFeeNote data={printData} />}
          {printComponent === "ProformaNote" && (
            <PrintProformaNote data={printData} />
          )}
          {printComponent === "CreditNote" && (
            <PrintCreditNote data={printData} />
          )}
          {printComponent === "ClientReceipt" && (
            <PrintReceipt data={printData} />
          )}
          {printComponent === "PrintInvoice" && (
            <PrintInvoice data={printData} />
          )}
          {printComponent === "PrintVoucher" && (
            <PrintVoucher data={printData} />
          )}
          {printComponent === "PrintPayslip" && (
            <PrintPayslip data={printData} />
          )}
        </DialogContent>
        <DialogActions className="no-print" sx={{ p: 2 }}>
          <Button
            onClick={() => setPrintOpen(false)}
            color="secondary"
            variant="outlined"
          >
            Close
          </Button>
          <Button
            onClick={() => {
              window.print();
            }}
            variant="contained"
            color="primary"
            startIcon={<PrintIcon />}
          >
            Print Now
          </Button>
        </DialogActions>
      </Dialog>

      {/* ---------- SELECT PAYROLL RUN MODAL ---------- */}
      <SelectPayrollRunModal
        open={payrollRunModalOpen}
        onClose={() => {
          setPayrollRunModalOpen(false);
          setPendingEmployeeId(null);
        }}
        employeeId={pendingEmployeeId}
        onPayrollSelected={fetchPayslipAndPrint}
      />

      <EngagementLetterModal
        data={editData}
        open={EngagementLetterModalOpen}
        onClose={() => setEngagementLetterModalOpen(false)}
        onAction={() => setRefreshTable(true)}
      />
      <CourtAttendanceSheetModal
        data={editData}
        open={CourtAttendanceSheetModalOpen}
        onClose={() => setCourtAttendanceSheetModalOpen(false)}
        onAction={() => setRefreshTable(true)}
      />
      {taskModalOpen && (
        <AssignTaskModal
          data={editData}
          open={taskModalOpen}
          onClose={() => setTaskModalOpen(false)}
          onAction={() => setRefreshTable(true)}
        />
      )}

      {assignDocumentAccessOpen && (
        <DocumentAccessModal
          data={editData}
          open={assignDocumentAccessOpen}
          onClose={() => setAssignDocumentAccessOpen(false)}
          onAction={() => setRefreshTable(true)}
        />
      )}
      {updateCaseStatus && (
        <UpdateCaseStatusModal
          data={editData}
          open={updateCaseStatus}
          onClose={() => setUpdateCaseStatusModalOpen(false)}
          onAction={() => setRefreshTable(true)}
        />
      )}
      {journalModal.open && (
        <JournalEntriesModal
          open={journalModal.open}
          onClose={() => setJournalModal((prev) => ({ ...prev, open: false }))}
          accountId={journalModal.accountId}
          accountName={journalModal.accountName}
          loading={journalModal.loading}
          journalData={journalModal.journalData}
        />
      )}

      {/* ---------- DISBURSEMENT MODAL ---------- */}
      {/* ---------- DISBURSE IMPREST MODAL ---------- */}
      <Dialog
        open={disburseImprestOpen}
        onClose={() => {
          setDisburseImprestOpen(false);
          setDisburseRow(null);
        }}
        maxWidth="md"
        q
        fullWidth
      >
        <DialogTitle>Disburse Imprest</DialogTitle>
        <DialogContent dividers>
          {disburseRow && (
            <ImprestDisbursementForm
              data={disburseRow}
              onClose={() => {
                setDisburseImprestOpen(false);
                setDisburseRow(null);
              }}
              refetchData={() => setRefreshTable((prev) => !prev)}
            />
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        open={disburseClaimOpen}
        onClose={() => {
          setDisburseClaimOpen(false);
          setDisburseRow(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Disburse Claim</DialogTitle>
        <DialogContent dividers>
          {disburseRow && (
            <ClaimDisbursementForm
              data={disburseRow}
              onClose={() => {
                setDisburseClaimOpen(false);
                setDisburseRow(null);
              }}
              refetchData={() => setRefreshTable((prev) => !prev)}
            />
          )}
        </DialogContent>
      </Dialog>
      {/* ---------- VIEW PAYROLL LINE DETAILS MODAL ---------- */}
      <ViewDetailDialog
        open={viewDetailOpen}
        onClose={() => {
          setViewDetailOpen(false);
          setDetailRow(null);
          setDetailData([]);
        }}
        title={`Payroll Line Details – ${detailRow?.employeeName || ""}`}
        columns={payrollLineDetailsColumns}
        rows={detailData}
        loading={detailLoading}
      />
      <AnchorTemporaryDrawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        FormComponent={() => (
          <FormComponent
            isEditing={isEditing}
            data={editData}
            onAction={() => setRefreshTable(true)}
            onClose={() => setDrawerOpen(false)}
            refetchData={() => setRefreshTable(true)}
          />
        )}
      />
      {isMobile && (
        <Dialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          fullScreen={isMobile}
        >
          <DialogTitle>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setDialogOpen(false)}
              aria-label="close"
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <FormComponent
              onClick={() => setDialogOpen(false)}
              isEditing={isEditing}
              data={editData}
              courtData={editData}
              onClose={() => setDialogOpen(false)}
              onAction={() => setRefreshTable(true)}
              refetchData={() => setRefreshTable(true)}
            />
          </DialogContent>
        </Dialog>
      )}

      {claimLinesDialogOpen && (
        <ManageClaimLinesWithDocuments
          open={claimLinesDialogOpen}
          onClose={() => {
            setClaimLinesDialogOpen(false);
            setSelectedClaimForLines(null);
          }}
          claimData={selectedClaimForLines}
          refetchData={() => setRefreshTable(true)}
        />
      )}

      {purchaseLinesDialogOpen && (
        <ManagePurchaseLinesDialog
          open={purchaseLinesDialogOpen}
          onClose={() => {
            setPurchaseLinesDialogOpen(false);
            setSelectedPurchaseForLines(null);
          }}
          purchaseData={selectedPurchaseForLines}
          refetchData={() => setRefreshTable(true)}
        />
      )}
      {/* Purchase Invoice lines dialog */}

      {paymentLinesDialogOpen && (
        <ManagePaymentVoucherLinesDialog
          open={paymentLinesDialogOpen}
          onClose={() => {
            setPaymentLinesDialogOpen(false);
            setSelectedPaymentForLines(null);
          }}
          paymentData={selectedPaymentForLines}
          refetchData={() => setRefreshTable(true)}
        />
      )}
      {/* Purchase Invoice lines dialog */}

      {statutoryRatesDialogOpen && (
        <ManageStatutoryRatesDialog
          open={statutoryRatesDialogOpen}
          onClose={() => {
            setStatutoryRatesDialogOpen(false);
            setSelectedStatutoryForRates(null);
          }}
          statutoryData={selectedStatutoryForRates}
          refetchData={() => setRefreshTable(true)}
        />
      )}
      {/* Statutory Rates lines dialog */}

      {relieversDialogOpen && (
        <ManageRelieversDialog
          open={relieversDialogOpen}
          onClose={() => {
            setRelieversDialogOpen(false);
            setSelectedLeaveApplicationForRelievers(null);
          }}
          leaveApplicationData={selectedLeaveApplicationForRelievers}
          refetchData={() => setRefreshTable(true)}
        />
      )}
      {/* relievers dialog */}

      {employeePayDialogOpen && (
        <ManageEmployeePayDialog
          open={employeePayDialogOpen}
          onClose={() => {
            setEmployeePayDialogOpen(false);
            setSelectedEmployeeForPayStructure(null);
          }}
          employeeData={selectedEmployeeForPayStructure}
          refetchData={() => setRefreshTable(true)}
        />
      )}
      {/* relievers dialog */}

      {imprestLinesDialogOpen && (
        <ManageImprestLinesWithDocuments
          open={imprestLinesDialogOpen}
          onClose={() => {
            setImprestLinesDialogOpen(false);
            setSelectedImprestForLines(null);
          }}
          imprestData={selectedImprestForLines}
          refetchData={() => setRefreshTable(true)}
        />
      )}
      {/* Imprest Lines Dialog */}

      {surrenderLinesDialogOpen && (
        <ManageSurrenderLinesDialog
          open={surrenderLinesDialogOpen}
          onClose={() => {
            setSurrenderLinesDialogOpen(false);
            setSelectedSurrenderForLines(null);
          }}
          surrenderData={selectedSurrenderForLines}
          refetchData={() => setRefreshTable(true)}
        />
      )}
      {/* Surrender Lines Dialog */}
    </Box>
  );
};

export default DynamicTable;
